import React, { useEffect, useRef, useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUser } from "../../redux/actions/userActions";
import { useHistory } from "react-router-dom";
import "../../css/login.css"; // Import the CSS file

const Login = ({ userValue, setUserValue, passwordValue, setPasswordValue }) => {
  const dispatch = useDispatch();
  const [notification, setNotification] = useState({ show: false, msg: "" });
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const safeSetNotification = (value) => {
    if (isMountedRef.current) setNotification(value);
  };

  const safeSetIsLoading = (value) => {
    if (isMountedRef.current) setIsLoading(value);
  };

  const handleRegisterClick = () => {
    history.push("/register");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    safeSetIsLoading(true);
    
    if (userValue === "") {
      safeSetNotification({ show: true, msg: "Username is required" });
      safeSetIsLoading(false);
      return;
    }
    if (passwordValue === "") {
      safeSetNotification({ show: true, msg: "Password is required" });
      safeSetIsLoading(false);
      return;
    }

    try {
      await dispatch(
        getUser({
          username: userValue,
          password: passwordValue,
          setNotification: safeSetNotification,
        })
      );
    } catch (err) {
      console.log(err);
    } finally {
      safeSetIsLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="login-header">
          <h2>Welcome Back</h2>
          <p>Please enter your credentials to login</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="user">Username</label>
            <Input
              name="user"
              type="text"
              value={userValue}
              autoComplete="username"
              placeholder="Enter your username"
              onChange={(e) => setUserValue(e.target.value)}
              tabIndex="1"
              className="styled-input"
            />
          </div>

          <div className="input-group">
            <div className="password-recover-wrapper">
              <label htmlFor="password">Password</label>
              <Link tabIndex="4" to="/recover" className="forgot-password">
                Forgot password?
              </Link>
            </div>
            <Input
              name="password"
              type="password"
              autoComplete="current-password"
              value={passwordValue}
              placeholder="Enter your password"
              onChange={(e) => setPasswordValue(e.target.value)}
              tabIndex="2"
              className="styled-input"
            />
          </div>

          {notification.show && (
            <p className="form-notification">{notification.msg}</p>
          )}

          <div className="button-group">
            <Button
              className="login-button"
              block={false}
              type="submit"
              fill={true}
              variant="primary"
              tabIndex="3"
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Log In"}
            </Button>

            <div className="divider">
              <span>or</span>
            </div>

            <Button
              className="register-button"
              block={true}
              type="button"
              fill=""
              variant="secondary"
              tabIndex="88"
              onClick={handleRegisterClick}
            >
              Create new account
            </Button>
          </div>
        </form>

        <div className="version-info">
          <span>Version: v2.0</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
